/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return -- globalThis.__intlCache is untyped by design (must work in compiled i18n context) */
// IMPORTANT: The formatter function must be fully self-contained with NO references
// to module-scoped variables or functions. The i18n message compiler (compile-messages)
// serializes these function bodies into standalone JS files (e.g. en.js), where
// module-scoped references like helper functions or caches are not in scope.
// Only language built-ins (globalThis, Map, Intl, Number) are safe to use.

export function puCurrency(value: number, locale: string, options?: string) {
  if (typeof value !== 'number') {
    return ''
  }
  const currency = getCurrencyFromOptions(options || '')
  const minFrac = getMinFractionDigitsFromOptions(options || '')
  const maxFrac = getMaxFractionDigitsFromOptions(options || '')

  const cache = ((globalThis as any).__intlCache ??= new Map())
  const cacheKey = `cur|${locale}|${currency}|${minFrac}|${maxFrac ?? ''}`
  let formatter = cache.get(cacheKey)
  if (!formatter) {
    const config: Intl.NumberFormatOptions = {
      style: 'currency',
      currency,
      currencyDisplay: 'symbol',
      minimumFractionDigits: minFrac,
    }
    if (maxFrac !== undefined) {
      config.maximumFractionDigits = maxFrac
    }
    formatter = new Intl.NumberFormat(locale, config)
    cache.set(cacheKey, formatter)
  }
  return formatter.format(value)

  function getCurrencyFromOptions(options: string): string {
    const currency = getFromOptions(options, 'currency')
    return currency || 'GBP'
  }

  function getMinFractionDigitsFromOptions(options: string): number {
    const minimumFractionDigits = getFromOptions(
      options,
      'minimumFractionDigits',
    )
    return minimumFractionDigits ? parseInt(minimumFractionDigits) : 2
  }

  function getMaxFractionDigitsFromOptions(options: string) {
    const maximumFractionDigits = getFromOptions(
      options,
      'maximumFractionDigits',
    )
    return maximumFractionDigits ? parseInt(maximumFractionDigits) : undefined
  }

  function getFromOptions(options: string, optionToFind: string): string {
    if (!options) {
      return ''
    }
    const option = options.split(' ').find((o) => o.startsWith(optionToFind))
    return option ? option.split(':')[1] : ''
  }
}
